/* eslint-disable react-hooks/exhaustive-deps */
import {useLayout, useMobileSidebar} from '../../core'
import {Navbar} from './Navbar'

export function HeaderWrapper() {
  const {config} = useLayout()
  const {isMobile, isOpen, toggle} = useMobileSidebar()
  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div
      id='kt_app_header'
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        left: isMobile ? 0 : '16rem',
        height: '4rem',
        zIndex: 105,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        boxShadow: '0 1px 12px 0 rgba(0, 52, 127, 0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: isMobile ? '0 0.75rem' : '0 2rem',
        gap: '0.5rem',
      }}
    >
      {/* Mobile sidebar toggle (hidden on desktop) */}
      <button
        type='button'
        id='kt_app_sidebar_mobile_toggle'
        className='d-flex d-lg-none'
        aria-label='Menu'
        aria-expanded={isOpen}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          toggle()
        }}
        style={{
          width: '2.25rem',
          height: '2.25rem',
          flexShrink: 0,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          color: '#434652',
        }}
      >
        <span className='material-symbols-outlined' style={{fontSize: '24px'}}>menu</span>
      </button>

      {/* Search bar */}
      <div className='header-search-wrap' style={{position: 'relative', flex: 1, maxWidth: '36rem'}}>
        <span
          className='material-symbols-outlined'
          style={{
            position: 'absolute',
            left: '0.75rem',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '20px',
            color: '#737783',
            pointerEvents: 'none',
          }}
        >
          search
        </span>
        <input
          type='text'
          placeholder='Search across all content...'
          style={{
            width: '100%',
            paddingLeft: '2.5rem',
            paddingRight: '1rem',
            paddingTop: '0.5rem',
            paddingBottom: '0.5rem',
            fontSize: '0.875rem',
            borderRadius: '9999px',
            border: 'none',
            outline: 'none',
            backgroundColor: '#f2f4f6',
            color: '#191c1e',
          }}
          onFocus={(e) => {
            e.target.style.boxShadow = '0 0 0 2px rgba(0, 104, 118, 0.4)'
          }}
          onBlur={(e) => {
            e.target.style.boxShadow = 'none'
          }}
        />
      </div>

      {/* Right section: actions + user */}
      <Navbar />
    </div>
  )
}
